<template>
  <div class="custom-variant-collection container critical-component-clear">
    <p
      v-if="title"
      class="custom-variant-collection__title text-mobile-headlines-h3 text-desktop-headlines-h3"
      v-text="title"
    />

    <product-grid
      template="custom"
      :handle="handle"
      :products-per-page="limit"
      :collection-product-count="count"
      :hide-soldout="hideSoldout"
      :infinite-scroll="infiniteScroll"
    />
  </div>
</template>

<script>
/**
 * Vue: Custom variant collection (custom-variant-collection)
 * -----------------------------------------------------------------------------
 * Custom list of variants referenced by a metaobject.
 *
 * @param {String} handle - Metaobject handle.
 * @param {String} title - Section title.
 * @param {Number} limit - Product limit.
 * @param {Number} count - Product count.
 */

import ProductGrid from '~async/product-grid/product-grid';

export default {
  name: 'CustomVariantCollection',

  components: {
    ProductGrid,
  },

  props: {
    handle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 24,
    },
    count: {
      type: Number,
      default: 0,
    },
    hideSoldout: {
      type: Boolean,
      default: false,
    },
    infiniteScroll: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
@import './custom-variant-collection';
</style>
